export const theme = {
  colors: {
    mainTextColor: '#E0E0E0',
    secondaryColor: '#fff',
    accentColor: '#6CEEC7',
  }
}